var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegulatoryCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_12340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.132 32H0V4C0 1.79467 1.79467 0 4 0H20C22.2053 0 24 1.79467 24 4V10.7453C23.5613 10.6973 23.1173 10.6667 22.6667 10.6667C22.216 10.6667 21.772 10.696 21.3333 10.7453V4C21.3333 3.264 20.736 2.66667 20 2.66667H4C3.264 2.66667 2.66667 3.264 2.66667 4V29.3333H12.6907C13.3653 30.3413 14.1907 31.2387 15.132 32ZM15.132 13.3333H5.33333V16H12.6907C13.3653 14.992 14.1907 14.0947 15.132 13.3333ZM5.33333 22.6667H10.6667C10.6667 21.7493 10.7787 20.8587 10.9747 20H5.33333V22.6667ZM32 22.6667C32 27.812 27.812 32 22.6667 32C17.5213 32 13.3333 27.812 13.3333 22.6667C13.3333 17.5213 17.5213 13.3333 22.6667 13.3333C27.812 13.3333 32 17.5213 32 22.6667ZM29.3333 22.6667C29.3333 18.9907 26.3427 16 22.6667 16C18.9907 16 16 18.9907 16 22.6667C16 26.3427 18.9907 29.3333 22.6667 29.3333C26.3427 29.3333 29.3333 26.3427 29.3333 22.6667ZM18.6667 6.66667H5.33333V9.33333H18.6667V6.66667ZM26.1187 19.5893L21.8147 23.8227L19.6413 21.716L17.784 23.6307L20.244 26.0147C20.6627 26.4347 21.2213 26.6667 21.816 26.6667C22.4107 26.6667 22.9693 26.4347 23.38 26.024L27.988 21.492L26.1187 19.5893Z",
    fill: "#543C7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_12340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegulatoryCompliance);
export default __webpack_public_path__ + "static/media/regulatory-compliance.4c2e6b891b5484826dde092f86e4e406.svg";
export { ForwardRef as ReactComponent };